function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import { login as _login, logout, getInfo as _getInfo } from '@/api/user';
import { areasLoginApi, areasGetAdminInfoByTokenApi, areasLogoutApi, areasGetMenusApi } from '@/api/area';
import { getToken, setToken as _setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import { isLoginApi } from '@/api/sms';
import Cookies from 'js-cookie';
import * as roleApi from '@/api/roleApi.js';
import { formatFlatteningRoutes } from '@/utils/system.js';
import { isPlatform } from '@/utils/settingMer';
import { patchKnownMenuTitles } from '@/utils/menuTitleFix';
function getMenusName() {
  var list;
  if (isPlatform) {
    list = JSON.parse(localStorage.getItem('MerPlatAdmin_MenuList')) || [];
  } else {
    list = localStorage.getItem('Circle_Admin_MenuList') ? JSON.parse(localStorage.getItem('Circle_Admin_MenuList')) : [];
  }
  patchKnownMenuTitles(list);
  return list;
}
var state = {
  token: getToken(),
  circleToken: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  circleRoles: [],
  isLogin: Cookies.get('isLogin'),
  permissions: [],
  circlePermissions: [],
  userInfo: null,
  // 存储完整的用户信息
  circleUserInfo: null,
  // 存储完整的用户信息
  captcha: {
    captchaVerification: '',
    secretKey: '',
    token: ''
  },
  //滑块验证token
  // 菜单数据
  menuList: getMenusName(),
  oneLvMenus: [],
  circleOneLvMenus: [],
  oneLvRoutes: JSON.parse(localStorage.getItem('MerPlatAdmin_oneLvRoutes')) || [],
  circleOneLvRoutes: JSON.parse(localStorage.getItem('Circle_Admin_oneLvRoutes')) || [],
  childMenuList: [],
  circleChildMenuList: []
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    if (isPlatform) {
      state.token = token;
    } else {
      state.circleToken = token;
    }
  },
  SET_ISLOGIN: function SET_ISLOGIN(state, isLogin) {
    state.isLogin = isLogin;
    Cookies.set('isLogin', isLogin);
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    if (isPlatform) {
      state.roles = roles;
    } else {
      state.circleRoles = roles;
    }
  },
  SET_PERMISSIONS: function SET_PERMISSIONS(state, permissions) {
    if (isPlatform) {
      state.permissions = permissions;
    } else {
      state.circlePermissions = permissions;
    }
  },
  SET_USER_INFO: function SET_USER_INFO(state, userInfo) {
    if (isPlatform) {
      state.userInfo = userInfo;
    } else {
      state.circleUserInfo = userInfo;
    }
  },
  SET_CAPTCHA: function SET_CAPTCHA(state, captcha) {
    state.captcha = captcha;
  },
  SET_MENU_LIST: function SET_MENU_LIST(state, menuList) {
    patchKnownMenuTitles(menuList);
    if (isPlatform) {
      state.menuList = menuList;
      localStorage.setItem('MerPlatAdmin_MenuList', JSON.stringify(menuList));
    } else {
      for (var i = 0; i < menuList.length; i++) {
        menuList[i].path = '/circle' + menuList[i].path;
        if (!menuList[i].children) {
          continue;
        }
      }
      state.menuList = menuList;
      localStorage.setItem('Circle_Admin_MenuList', JSON.stringify(menuList));
    }
  },
  setOneLvMenus: function setOneLvMenus(state, oneLvMenus) {
    if (isPlatform) {
      state.oneLvMenus = oneLvMenus;
    } else {
      for (var i = 0; i < oneLvMenus.length; i++) {
        oneLvMenus[i].path = '/circle' + oneLvMenus[i].path;
      }
      state.circleOneLvMenus = oneLvMenus;
    }
  },
  setOneLvRoute: function setOneLvRoute(state, oneLvRoutes) {
    if (isPlatform) {
      state.oneLvRoutes = oneLvRoutes;
    } else {
      state.circleOneLvRoutes = oneLvRoutes;
    }
  },
  childMenuList: function childMenuList(state, list) {
    if (isPlatform) {
      state.childMenuList = list;
    } else {
      state.circleChildMenuList = list;
    }
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit,
      dispatch = _ref.dispatch;
    var account = userInfo.account,
      pwd = userInfo.pwd,
      key = userInfo.key,
      code = userInfo.code,
      wxCode = userInfo.wxCode;
    return new Promise(function (resolve, reject) {
      // 根据环境变量判断调用不同的登录API
      var loginApi = isPlatform ? _login : areasLoginApi;
      loginApi(userInfo).then(function (data) {
        commit('SET_TOKEN', data.token);
        if (isPlatform) {
          Cookies.set('JavaPlatInfo', JSON.stringify(data));
        } else {
          Cookies.set('CircleJavaPlatInfo', JSON.stringify(data));
        }
        _setToken(data.token);
        // 清空之前用户的tab缓存，避免权限冲突
        commit('menu/clearAll', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 短信是否登录
  isLogin: function isLogin(_ref2, userInfo) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      isLoginApi().then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                commit('SET_ISLOGIN', res.isLogin);
                resolve(res);
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (res) {
        commit('SET_ISLOGIN', false);
        reject(res);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      // 根据环境变量判断调用不同的获取用户信息API
      var getUserInfoApi = isPlatform ? function () {
        return _getInfo(state.token);
      } : areasGetAdminInfoByTokenApi;
      getUserInfoApi().then(function (data) {
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var roles = data.roles,
          account = data.account;
        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        commit('SET_ROLES', roles);
        // commit('SET_ROLES', ['admin'])
        commit('SET_NAME', account);
        // commit('SET_AVATAR', avatar)
        commit('SET_AVATAR', 'http://kaifa.crmeb.net/system/images/admin_logo.png');
        commit('SET_INTRODUCTION', 'CRMEB admin');
        commit('SET_PERMISSIONS', data.permissionsList); //权限标识
        commit('SET_USER_INFO', data); // 存储完整的用户信息
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  handleLogout: function handleLogout(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state,
      dispatch = _ref5.dispatch;
    return new Promise(function (resolve, reject) {
      // 根据环境变量判断调用不同的退出登录API
      var logoutApi = isPlatform ? function () {
        return logout(state.token);
      } : areasLogoutApi;
      logoutApi().then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        commit('SET_PERMISSIONS', []);
        removeToken();
        // localStorage.clear();
        Cookies.remove('storeStaffList');
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        if (isPlatform) {
          Cookies.remove('JavaPlatInfo');
          sessionStorage.removeItem('token');
          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          resetRouter();
          resolve();
        } else {
          Cookies.remove('CircleJavaPlatInfo');
          resetRouter();
          resolve();
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref6) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      // 清空tab缓存，避免无权限的菜单残留
      commit('menu/clearAll', null, {
        root: true
      });
      resolve();
    });
  },
  // 设置token
  setToken: function setToken(_ref7, state) {
    var commit = _ref7.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', state.token);
      if (isPlatform) {
        Cookies.set('JavaPlatInfo', JSON.stringify(state));
      } else {
        Cookies.set('CircleJavaPlatInfo', JSON.stringify(state));
      }
      _setToken(data.token);
      resolve();
    });
  },
  getMenus: function getMenus(_ref8) {
    var commit = _ref8.commit,
      dispatch = _ref8.dispatch;
    function formatTwoStageRoutes(arr) {
      if (arr.length <= 0) return false;
      var newArr = [];
      var cacheList = [];
      arr.forEach(function (v) {
        if (v && v.meta && v.meta.keepAlive) {
          newArr.push(_objectSpread({}, v));
          cacheList.push(v.name);
          dispatch('keepAliveNames/setCacheKeepAlive', cacheList, {
            root: true
          });
        }
      });
      return newArr;
    }
    return new Promise(/*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resolve, reject) {
        var getMenuApi, accessRoutes, arr, routes, _arr, _routes, i, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              getMenuApi = isPlatform ? roleApi.menuListApi : areasGetMenusApi;
              _context2.n = 1;
              return getMenuApi();
            case 1:
              accessRoutes = _context2.v;
              commit('SET_MENU_LIST', accessRoutes);
              if (isPlatform) {
                arr = formatFlatteningRoutes(router.options.routes);
                formatTwoStageRoutes(arr);
                routes = formatFlatteningRoutes(accessRoutes);
                localStorage.setItem('MerPlatAdmin_oneLvRoutes', JSON.stringify(routes));
                commit('setOneLvMenus', arr);
                commit('setOneLvRoute', routes);
              } else {
                _arr = formatFlatteningRoutes(router.options.routes);
                formatTwoStageRoutes(_arr);
                _routes = formatFlatteningRoutes(accessRoutes);
                for (i = 0; i < _routes.length; i++) {
                  if (_routes[i].path && _routes[i].path.split('/')[1] !== 'circle') {
                    _routes[i].path = '/circle' + _routes[i].path;
                  }
                }
                localStorage.setItem('Circle_Admin_oneLvRoutes', JSON.stringify(_routes));
              }
              resolve();
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              reject(_t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function (_x2, _x3) {
        return _ref9.apply(this, arguments);
      };
    }());
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};